import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import ClientService from "../../../biletyApi/ClientService";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import DefinicjeService from "../../../../trasyConfig/definicjeTras/DefinicjeService";

export default class PokazCenyZeZnizkamiSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            data: moment(),
            kursy: [],
            kurs: null,
            przystanekOd: null,
            przystanekDo: null,

            przystankiNaTrasie: [],

        }
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangePrzystanekOd = this.onChangePrzystanekOd.bind(this)
        this.onChangePrzystanekDo = this.onChangePrzystanekDo.bind(this)
        this.onChangeKurs = this.onChangeKurs.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onClickPokaz = this.onClickPokaz.bind(this)
    };


    pobierzDefinicjeTrasy(trasa) {
        DefinicjeService.getDefinicjeWTrasie(trasa.idTr).then(function (response) {
            if (response.data.length > 0) {

                let arr = Array.from(response.data, item => {
                    return {
                        ...item,
                        info: item.nazMi + ' ' + item.nazPr
                    }
                })

                this.setState({
                    przystanekOd: arr[0],
                    przystanekDo: arr[response.data.length - 1],
                    przystankiNaTrasie: arr,
                })
                this.pobierzKursy(this.state.data, arr[0], arr[arr.length - 1],trasa)
            }
        }.bind(this))
    }

    pobierzKursy(data, pod, pdo,trasa=this.state.trasa) {
        this.setState({kursy: [], kurs: null})
        let obj = {
            "data": DateAndTimeFormat.formatYYYYMMDD(data),
            "godz": "00:00",
            "idPrDo": pdo.idPr,
            "idPrOd": pod.idPr
        }
        ClientService.getKursyMiedzyPrzystankamiWDanymCzasie(obj).then(function (response) {
            if (response.data.length > 0) {
                if(Boolean(trasa)){
                    let arr = response.data.filter(k=>k.idTr === trasa.idTr)
                    this.setState({
                        kursy: arr, kurs: arr[0]
                    })

                }else{
                    this.setState({kursy: response.data, kurs: response.data[0]})

                }
            }
        }.bind(this))
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr}
            <TopDostepnosc wartoscWarunek={0}
                           wartosc={option.status}
                           czyMarginesLewy={true}
            />
        </div>
    }

    renderKursyOption(option) {
        return <div>
            <span style={{marginRight: '15px'}} title={'Numer kursu'}>
                <span className={'label label-ebus-secondary'}>{option.idKu}</span>
            </span>
            <span style={{marginRight: '10px', fontWeight: 'bold'}}>
                {option.nazMiOd} <i className={'fa fa-long-arrow-right'}></i> {option.nazMiDo}
            </span>
            <span>
                Odjazd o <span className={'label label-ebus-primary'} style={{marginLeft: '3px'}}>{option.godz}</span>
            </span>
            <span style={{margin: '0 6px'}}>
                Przyjazd o <span className={'label label-ebus-default'} style={{marginLeft: '3px'}}>{option.godzPrzy}</span>
            </span>
        </div>
    }

    onChangeTrasa(e) {
        this.props.handleWyczyscSzukanie();
        this.setState({trasa: e})
        if (e !== null) {
            this.pobierzDefinicjeTrasy(e)
        }
    }

    onChangePrzystanekOd(e) {
        this.props.handleWyczyscSzukanie();
        this.setState({przystanekOd: e})
        if (e !== null && Boolean(this.state.przystanekDo)) {
            this.pobierzKursy(this.state.data, e, this.state.przystanekDo)
        }
    }

    onChangePrzystanekDo(e) {
        this.props.handleWyczyscSzukanie();
        this.setState({przystanekDo: e})
        if (e !== null && Boolean(this.state.przystanekOd)) {
            this.pobierzKursy(this.state.data, this.state.przystanekOd, e)
        }
    }

    onChangeData(e) {
        this.props.handleWyczyscSzukanie();
        this.setState({data: e})
        if (e !== null) {
            if (Boolean(this.state.przystanekOd) && Boolean(this.state.przystanekDo)) {
                this.pobierzKursy(e, this.state.przystanekOd, this.state.przystanekDo)
            }
        }
    }

    onChangeKurs(e) {
        this.props.handleWyczyscSzukanie();
        this.setState({kurs: e})
    }

    onClickPokaz() {

        let proprawne = true

        if (!Boolean(this.state.kurs) || !Boolean(this.state.data)) {
            alert('Nie uzupełniono wszystkich pól!')
            proprawne = false
        }

        if (Boolean(this.state.przystanekOd) && Boolean(this.state.przystanekDo)) {
            if (this.state.przystanekOd.kol > this.state.przystanekDo.kol) {
                alert('Niepoprawna kolejność przystanków!')
                proprawne = false
            }
        }

        if (proprawne) {
            this.props.handleClickPokaz(this.state.trasa, this.state.przystanekOd, this.state.przystanekDo, DateAndTimeFormat.formatYYYYMMDD(this.state.data), this.state.kurs)
        }
    }

    renderPrzystanek(option) {
        return (<div>
            <span className={'label label-ebus-primary'}>{option.nazMi}</span> {option.nazPr}
        </div>)
    }

    render() {

        return (
            <div>
                <Form horizontal={'true'}>
                    <FormGroup>
                        <Col xs={12} lg={3}>
                            <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                       valueKey={'idTr'} labelKey={'nazTr'}
                                       valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect} placeholder={'Wybierz trasę...'}
                            />
                        </Col>
                        <Col xs={12} lg={3}>
                            <ControlLabel>Od przystanku <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={this.onChangePrzystanekOd} value={this.state.przystanekOd}
                                       options={this.state.przystankiNaTrasie}
                                       valueKey={'idPr'} labelKey={'info'}
                                       valueRenderer={this.renderPrzystanek} optionRenderer={this.renderPrzystanek}
                                       clearable={false} disabled={!Boolean(this.state.trasa)}
                            />
                        </Col>
                        <Col xs={12} lg={3}>
                            <ControlLabel>Do przystanku <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={this.onChangePrzystanekDo} value={this.state.przystanekDo}
                                       options={this.state.przystankiNaTrasie}
                                       valueKey={'idPr'} labelKey={'info'}
                                       valueRenderer={this.renderPrzystanek} optionRenderer={this.renderPrzystanek}
                                       clearable={false} disabled={!Boolean(this.state.trasa)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12} lg={2}>
                            <ControlLabel>Data <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate horizontal={true} onChange={this.onChangeData} value={this.state.data}/>
                        </Col>
                        <Col xs={12} lg={7}>
                            <ControlLabel>Kurs <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={this.onChangeKurs} value={this.state.kurs} options={this.state.kursy}
                                       valueKey={'idKu'} labelKey={'idKu'} valueRenderer={this.renderKursyOption}
                                       optionRenderer={this.renderKursyOption}
                                       disabled={!Boolean(this.state.trasa)} clearable={false}
                            />
                        </Col>
                        <Col xs={12} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction btnSize={'medium'} text={'Pokaż ceny i zniżki'} iconType={'fa fa-percent'} onClick={this.onClickPokaz}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokażCenyZeZnizkami/components/PokazCenyZeZnizkamiSearchbox.js